import { ChannelType } from 'common/core/constants/ChannelType'
import { api } from 'shared/api'

import { ChatApiSchemas } from './schemas'
import { snipppetsSchemas } from './snippets/schemas'
import { threadsSchemas } from './threads/schemas'

export const chatApi = {
  threads: {
    fetch: api.account.createPost({
      url: '/im/loadThreads',
      schemas: threadsSchemas.fetch,
      scope: 'livechat',
      section: 'thread',
    }),
    fetchThread: api.account.createGet({
      url: '/im/loadThread',
      schemas: threadsSchemas.fetchThread,
      scope: 'livechat',
      section: 'thread',
    }),
    bulk: api.account.createPost({
      url: '/im/bulk',
      schemas: threadsSchemas.bulk,
      scope: 'livechat',
      section: 'thread',
    }),
    checkThreadSatisfiesFilter: api.account.createPost({
      url: '/im/checkThreadSatisfiesFilter',
      schemas: threadsSchemas.checkThreadSatisfiesFilter,
      scope: 'livechat',
      section: 'thread',
    }),
    loadThreadPartialDetails: api.account.createGet({
      url: '/im/loadThreadPartialDetails',
      schemas: threadsSchemas.loadThreadPartialDetails,
      scope: 'livechat',
      section: 'thread',
    }),
    takeThreadControl: api.account.createPost({
      url: '/im/takeThreadControl',
      schemas: threadsSchemas.takeThreadControl,
      scope: 'livechat',
      section: 'thread',
    }),
    closeAllThreads: api.account.createPost({
      url: '/im/closeAllThreads',
      schemas: threadsSchemas.closeAllThreads,
      scope: 'livechat',
      section: 'thread',
    }),
    updateThreadStatus: api.account.createPost({
      url: '/im/updateThreadStatus',
      schemas: threadsSchemas.updateThreadStatus,
      scope: 'livechat',
      section: 'thread',
    }),
    setAssignment: api.account.createPost({
      url: '/im/setAssignment',
      schemas: threadsSchemas.setAssignment,
      scope: 'livechat',
      section: 'thread',
    }),
    markThreadAsRead: api.account.createPost({
      url: '/im/markThreadAsRead',
      schemas: threadsSchemas.markThreadAsRead,
      scope: 'livechat',
      section: 'thread',
    }),
    markThreadAsUnread: api.account.createPost({
      url: '/im/markThreadAsUnread',
      schemas: threadsSchemas.markThreadAsUnread,
      scope: 'livechat',
      section: 'thread',
    }),
    setPauseForever: api.account.createPost({
      url: '/im/setAutomationPauseForever',
      schemas: threadsSchemas.setAutomationPauseForever,
      scope: 'livechat',
      section: 'automation_pause',
    }),
    setPause: api.account.createPost({
      url: '/im/setAutomationPause',
      schemas: threadsSchemas.setAutomationPause,
      scope: 'livechat',
      section: 'automation_pause',
    }),
    clearPause: api.account.createPost({
      url: '/im/clearAutomationPause',
      schemas: threadsSchemas.clearPause,
      scope: 'livechat',
      section: 'automation_pause',
    }),
  },
  messages: {
    fetch: api.account.createGet({
      url: '/im/loadMessages',
      schemas: ChatApiSchemas.messages.fetch,
      scope: 'livechat',
      section: 'message',
    }),
    sendFacebook: api.account.createPost({
      url: '/im/sendMessage',
      schemas: ChatApiSchemas.messages.sendFacebook,
      scope: 'livechat',
      section: 'message',
    }),
    createNote: api.account.createPost({
      url: '/im/createNote',
      schemas: ChatApiSchemas.messages.createNote,
      scope: 'livechat',
      section: 'message',
    }),
    sendInstagram: api.account.createPost({
      url: '/im/sendInstagramMessage',
      schemas: ChatApiSchemas.messages.sendInstagram,
      scope: 'livechat',
      section: 'message',
    }),
    sendTelegram: api.account.createPost({
      url: '/im/sendTelegramMessage',
      schemas: ChatApiSchemas.messages.sendTelegram,
      scope: 'livechat',
      section: 'message',
    }),
    sendFlow: api.account.createPost({
      url: '/im/sendFlow',
      schemas: ChatApiSchemas.messages.sendFlow,
      scope: 'livechat',
      section: 'message',
    }),
    sendWhatsApp: api.account.createPost({
      url: '/im/sendWhatsAppMessage',
      schemas: ChatApiSchemas.messages.sendWhatsApp,
      scope: 'livechat',
      section: 'message',
    }),
    sendSMS: api.account.createPost({
      url: '/im/sendSMS',
      schemas: ChatApiSchemas.messages.sendSMS,
      scope: 'livechat',
      section: 'message',
    }),
    sendTiktok: api.account.createPost({
      url: '/im/sendTiktokMessage',
      schemas: ChatApiSchemas.messages.sendTiktok,
      scope: 'livechat',
      section: 'message',
    }),
  },
  snippets: {
    fetchSnippets: api.account.createGet({
      url: 'im/liveChatSnippet/list',
      schemas: snipppetsSchemas.fetchSnippets,
      scope: 'livechat',
      section: 'canned_response',
    }),
    createSnippet: api.account.createPost({
      url: 'im/liveChatSnippet/create',
      schemas: snipppetsSchemas.createSnippet,
      scope: 'livechat',
      section: 'canned_response',
    }),
    deleteSnippet: api.account.createPost({
      url: 'im/liveChatSnippet/delete',
      schemas: snipppetsSchemas.deleteSnippet,
      scope: 'livechat',
      section: 'canned_response',
    }),
    editSnippet: api.account.createPost({
      url: 'im/liveChatSnippet/edit',
      schemas: snipppetsSchemas.editSnippet,
      scope: 'livechat',
      section: 'canned_response',
    }),
    transformContentSnippet: api.account.createPost({
      url: 'im/liveChatSnippet/transformContent',
      schemas: snipppetsSchemas.transformContentSnippet,
      scope: 'livechat',
      section: 'canned_response',
    }),
  },
  labels: {
    fetch: api.account.createGet({
      url: 'labels/list',
      schemas: ChatApiSchemas.labels.fetch,
      scope: 'livechat',
      section: 'label',
    }),
    create: api.account.createPost({
      url: 'labels/create',
      schemas: ChatApiSchemas.labels.create,
      scope: 'livechat',
      section: 'label',
    }),
    update: api.account.createPost({
      url: 'labels/update',
      schemas: ChatApiSchemas.labels.update,
      scope: 'livechat',
      section: 'label',
    }),
    delete: api.account.createPost({
      url: 'labels/delete',
      schemas: ChatApiSchemas.labels.delete,
      scope: 'livechat',
      section: 'label',
    }),
  },
}

export const SendFunction = {
  [ChannelType.FB]: chatApi.messages.sendFacebook,
  [ChannelType.INSTAGRAM]: chatApi.messages.sendInstagram,
  [ChannelType.WHATSAPP]: chatApi.messages.sendWhatsApp,
  [ChannelType.TELEGRAM]: chatApi.messages.sendTelegram,
  [ChannelType.TIKTOK]: chatApi.messages.sendTiktok,
  [ChannelType.SMS]: chatApi.messages.sendSMS,
} as const
